const isTestEnv = ['test', 'ui_test'].includes(window.env.name)

export default isTestEnv
